import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';
import { StarSolidIcon } from '@mentimeter/ragnar-visuals';
import {
  PopoverBody,
  PopoverDescription,
  PopoverFooter,
  PopoverHeader,
} from '../../components/Popover';

interface Props {
  title: string;
  description: string;
  width?: string;
  isEducational: boolean;
  badge?: 'pro' | 'basic' | undefined;
  trackClickUpgrade: () => void;
  onDismissClick: () => void;
}

export const SelfUpgradePopoverContentGeneric = ({
  title,
  width = '300px',
  description,
  isEducational,
  badge,
  trackClickUpgrade,
  onDismissClick,
}: Props) => {
  const t = useTranslations('purchasing');

  return (
    <Box width={width}>
      <PopoverHeader badge={badge} onDismissClick={onDismissClick}>
        {title}
      </PopoverHeader>

      <PopoverBody>
        <PopoverDescription>{description}</PopoverDescription>
      </PopoverBody>

      <PopoverFooter>
        <Button
          href={isEducational ? '/plans/education' : '/plans'}
          target="_blank"
          variant="positive"
          onClick={trackClickUpgrade}
          size="compact"
          iconLeading={badge ? undefined : StarSolidIcon}
        >
          {t('self_upgrade_popover_see_plans_button')}
        </Button>
      </PopoverFooter>
    </Box>
  );
};
